"use client";

import React, { useCallback } from "react";
import { useRouter } from "next/navigation";
import { Box } from "@mui/material";
import Breadcrumbs from "@/components/Breadcrumbs";
import { useSnackbar } from "@/context/SnackbarContext";
import ArticleHeader from "./ArticleHeader";
import ArticleImageCard from "./ArticleImageCard";
import ArticleBody from "./ArticleBody";
import ArticleActions from "./ArticleActions";
import { highlightCode } from "@/utils/highlightCode";
import CustomStyles from "./CustomStyles";

export default function ArticleContent({ article, hideBreadcrumbs = false }) {
  const router = useRouter();
  const { showSnackbar } = useSnackbar();

  const articleCategoryName = article?.category?.name || "general";
  const articleCategorySlug = article?.category?.slug || "general";
  const articleContent = article?.content || "Article content goes here.";

  const handleShareClick = useCallback(() => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      showSnackbar("Share link copied to your clipboard.", "success");
    });
  }, [showSnackbar]);

  const handleEditClick = useCallback(() => {
    router.push(`/edit/${article?.slug}`);
  }, [router, article?.slug]);

  const highlightedContent = highlightCode(articleContent);

  return (
    <div>
      <CustomStyles />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "800px",
          margin: "0 auto",
          padding: "1rem",
        }}
      >
        {!hideBreadcrumbs && (
          <Box sx={{ width: "100%", mb: 1 }}>
            <Breadcrumbs
              categoryName={articleCategoryName}
              categorySlug={articleCategorySlug}
            />
          </Box>
        )}
        <article style={{ width: "100%" }}>
          <Box sx={{ position: "relative", width: "100%" }}>
            <ArticleImageCard article={article} />
            
            {/* Featured Badge - bottom left */}
            {article.featured && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: "-20px",
                  left: "5%",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  backgroundColor: "rgba(0, 0, 0, 0.8)",
                  color: "#FFD700",
                  padding: "8px 14px",
                  borderRadius: "20px",
                  fontWeight: "bold",
                  fontSize: "0.9rem",
                  zIndex: 10,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                }}
              >
                <span style={{ fontSize: "1rem" }}>⭐</span>
                Featured
              </Box>
            )}
            
            <ArticleActions
              onEditClick={handleEditClick}
              onShareClick={handleShareClick}
              articleLikeCount={article.likeCount}
              articleSlug={article.slug}
            />
          </Box>

          <ArticleHeader article={article} />
          <ArticleBody content={highlightedContent} />
        </article>
      </Box>
    </div>
  );
}
